import { ActionTree, Commit } from 'vuex';
import { ViewVinRegistrationDTO} from 'src/services/generated/api.generated.v1';
import { StateInterface } from '../index';
import { VehicleService } from 'src/services';
import { VehicleStateInterface } from './state';


const actions: ActionTree<VehicleStateInterface, StateInterface> = {
    async loadVinRegistrations({ commit }: { commit: Commit }): Promise<void> {
        const registrations: Array<ViewVinRegistrationDTO> = await VehicleService.GetInstance().GetVinRegistrations();

        commit('setVinRegistrations', registrations);        
    },

    async loadClaims({ commit }: { commit: Commit }, { vehicleUid }: { vehicleUid: string}): Promise<void> {
        const claims = await VehicleService.GetInstance().GetClaims(vehicleUid);

        commit('setClaims', { vehicleUid: vehicleUid, claims: claims});
    },

    async loadRecalls({ commit }: { commit: Commit }, { vehicleUid }: { vehicleUid: string}): Promise<void> {
        const recalls = await VehicleService.GetInstance().GetRecalls(vehicleUid);

        commit('setRecalls', { vehicleUid: vehicleUid, recalls: recalls});        
    },

    async loadSalesOrders({ commit }: { commit: Commit }, { vehicleUid }: { vehicleUid: string}): Promise<void> {
        const salesOrders = await VehicleService.GetInstance().GetSalesOrders(vehicleUid);

        commit('setSalesOrders', { vehicleUid: vehicleUid, salesOrders: salesOrders});        
    }
};

export default actions;
